import React, {useState, useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux';
import {hostUrl, setSpinner, siteUrl, highTrafficInnerPages, invalidUsername, invalidPassword, highTrafficLogin, passwordWeak, passwordMedium, confirPasswordNotMatched } from '../constants/global';
//import {loadingSection} from './common/Helper';
import { callPageRenderTracking } from './common/Helper';

function MyAccount() {

    var loadingSection = <div className='loading'>Loading...</div>;


    const [displayname, setDisplayName] = useState("");
    const [isChecked, setIsChecked] = useState(false);

    const [responsemessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const [saveoading, setSaveLoading] = useState(false);

    useEffect(() => {

        callPageRenderTracking({page_title:'My Account',page_link:window.location.href});

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";
        
        var token = 'Bearer '+storageData.token;
        var username = storageData.user_email;

        const data = { callingaction: 'get_custom_display_name' };

        const requestOptions = {
                method: 'POST',
                //mode:'cors',
                headers: { 'Content-Type': 'application/json', 
                'POST' : '/resource HTTP/1.1',
                'Authorization': token,
                'Host' : hostUrl,
                'username' : username,
                body: JSON.stringify(data),
                }
            };

       

        fetch(siteUrl+'/community-rest-functions.php?action=user_handle',requestOptions)
        .then((response) => response.json())
        .then(function(actualData){ 
            
            console.log(actualData, 'asdsadasdsadsa');
            setDisplayName(actualData.data.display_name);
            if(actualData.data.anonymously==="1"){
                setIsChecked(true);
            }

            setLoading(false);
            //setResponseMessage({status:"success",message:"We have send the topic for approval"});
        
        
        }).catch(rejected => {
            //setResponseMessage({status:"error",message:highTrafficInnerPages});
        });

        /*******add class on body*****/
        document.body.classList.add('white-bg-header');
        return () => {
        document.body.classList.remove('white-bg-header');
        }

    },[]);

    const submitForm = (e)=> {
        e.preventDefault();

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";
        
        var token = 'Bearer '+storageData.token;
        var username = storageData.user_email;

        const data = { callingaction: 'update_custom_display_name', customdisplayname : displayname, anonymously : isChecked };

        const requestOptions = {
                method: 'POST',
                //mode:'cors',
                headers: { 'Content-Type': 'application/json', 
                'POST' : '/resource HTTP/1.1',
                'Authorization': token,
                'Host' : hostUrl,
                'username' : username,
                body: JSON.stringify(data),
                }
            };

        setSaveLoading(true);
        fetch(siteUrl+'/community-rest-functions.php?action=user_handle',requestOptions)
        .then((response) => response.json())
        .then(function(actualData){ 
            
            setResponseMessage({status:"success",message:"saved successfully"});
            setSaveLoading(false);
        
        }).catch(rejected => {
            //setResponseMessage({status:"error",message:highTrafficInnerPages});
        });
    }

    const handleInputChange = (e) => {
        if(e.target.name==="displayname"){
            setDisplayName(e.target.value);
        }

        if(e.target.name==="profile-anonymously"){
            setIsChecked(!isChecked);

            if(!isChecked){

                /******get data from localstorage*******/
                let authlogin = localStorage.getItem('authlogin');
                let storageData = authlogin ? JSON.parse(authlogin) : "";

                setDisplayName("User"+storageData.authid);
            }
        }
    }


  return (
    <div className='fullpage-box'>
    <div className="topic-container">

    <h2 className='page-title'>My Account</h2>

        {loading && loadingSection}

        {loading===false && 
            <form onSubmit={submitForm}>

            <div className="topic-field">
                <label>Display Name: </label>
                <textarea value={displayname} readOnly={isChecked} name="displayname" onChange={(e) => handleInputChange(e)} />
            </div>

            <div className="topic-checkbox">
            <input type="checkbox" id="profile-anonymously" name="profile-anonymously" checked={isChecked} onChange={(e) => handleInputChange(e)} />
                    <label htmlFor="profile-anonymously"> Profile Anonymously</label>
                
            </div>


            <div className="form-group user-checkbox">
                
                    
            </div>

            
            <button type="submit" className="submit-topic">{saveoading && <span class="material-icons-outlined spin">motion_photos_on</span>}Save</button>
            

            {responsemessage && <span className="response-message">{responsemessage.message}</span>}


            </form>
        }

    </div>
    </div>
  )
}

export default MyAccount;